import {Component} from '@angular/core';
import {TradingPlanForQualityGates} from "../../../../../api/models/trading-plan-for-quality-gates";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {
  TradingPlansByIssuerAndInsiderNameService
} from "../../../../../api/services/trading-plans-by-issuer-and-insider-name.service";

@Component({
  selector: 'app-view-trading-plans',
  templateUrl: './view-trading-plans.component.html',
  styleUrl: './view-trading-plans.component.css',
  standalone: false
})
export class ViewTradingPlansComponent {

  listOfEntries: TradingPlanForQualityGates[] = [];
  first = 0;
  readonly paginator = {pageSize: 1, pageNumber: 1, totalCount: 1};
  loading = false;

  constructor(private ref: DynamicDialogRef,
              private _tradingPlansService: TradingPlansByIssuerAndInsiderNameService,
              public config: DynamicDialogConfig) {
    this.loading = true;
    this._tradingPlansService.getTradingPlansByIssuerAndIssuerNames({
      issuerName: config.data.issuerName?.trim(),
      insiderName: config.data.insiderName?.trim()
    }).subscribe({
      next: value => {
        this.listOfEntries = value.filter(t => t.planAction == 'ADOPTION')
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onSelectClick(share: any, connect: string) {
    this.ref.close(share);
  }
}
